<template>
  <img 
    :src="src || url" 
    :className="className"
    :style="{
      width: size || width,
      height: size || height,
      ...style
    }"
  />
</template>

<script setup>
import { computed } from 'vue';


// 定义组件的 props
const props = defineProps({
  name: {
    type: String,
    default: '',
  },
  src: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'png',
  },
  width: {
    type: String,
    default: '16px',
  },
  height: {
    type: String,
    default: '16px',
  },
  className: {
    type: String,
    default: ''
  },
  // 如果需要外部传入 style 对象，可以添加这个 prop
  style: {
    type: Object,
    default: () => ({}),
  }
});
const getImageUrl = (url) => {
  return new URL(`../../assets/${url}`, import.meta.url).href
}
// 计算属性
const url = computed(() => {
  return getImageUrl(`img/icon/${props.name}.${props.type}`);
});
</script>
